import { useEffect, useState } from "react";
import { FaInstagram, FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { LuFacebook, LuMessageCircle } from "react-icons/lu";
import { MdOutlineEmail } from "react-icons/md";
import { getFirestore, collection, doc, query, where, orderBy, onSnapshot, getDoc } from "firebase/firestore";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";

export default function Footer() {
    const [revenda, setRevenda] = useState({});

    const navLinks = [
        { href: "/", label: "Home" },
        { href: "/estoque", label: "Estoque" },
        { href: "/financiamento", label: "Financiamento" },
        { href: "/venda", label: "Venda" },
        { href: "/contato", label: "Contato" },
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
        const firestore = getFirestore(app);

        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setRevenda(docSnap.data());
            }
        });

        const q = query(
            collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
            where("veremovido", "==", 0),
            where("vevendido", "==", 0),
            orderBy("updated_at", "desc")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                document.id = doc.id;
                if (document["veexibir_site"] !== false) {
                    items.push(document);
                }
            });
        });

        return () => unsubscribe();
    }, []);

    return (
        <footer className="bg-white text-black px-4 md:px-8 py-10">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <img
                        src="/logo-white.png"
                        alt="Mult Veículos Logo"
                        width={200}
                        height={100}
                        className="mb-4"
                    />

                    <p className="text-sm mb-4">
                       Sua Loja de confiança para comprar e negociar veículos de qualidade!
                    </p>

                    <div className="flex gap-4 text-xl">
                        <a href={revenda.facebook_link} className="hover:text-gray-300">
                            <LuFacebook />
                        </a>
                        <a href={revenda.instagram_link} className="hover:text-gray-300">
                            <FaInstagram />
                        </a>
                        <a href={"https://api.whatsapp.com/send?phone=55" + retiraMascara(revenda.petelefone2, "link")} className="hover:text-gray-300">
                            <LuMessageCircle />
                        </a>
                    </div>
                </div>

                <div>
                    <h2 className="text-lg font-semibold mb-4">Links Rápidos</h2>
                    <nav>
                        <ul className="space-y-2 text-sm">
                            {navLinks.map((link) => (
                                <li key={link.href}>
                                    <a
                                        href={link.href}
                                        className="hover:underline"
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>

                <div>
                    <h2 className="text-lg font-semibold mb-4">Contato</h2>

                    <div className="space-y-3 text-sm">
                        <div className="flex items-start gap-2">
                            <FaLocationDot className="mt-1" />
                            <p>{revenda.peendereco_fiscal}, {revenda.peendereco_fiscal_numero} – {revenda.pebairro_fiscal}, {revenda.pecidade} - {revenda.peuf}</p>
                        </div>

                        <div className="flex items-center gap-2">
                            <FaPhoneAlt />
                            <p>{retiraMascara(revenda.petelefone1)}</p>
                        </div>

                        <div className="flex items-center gap-2">
                            <LuMessageCircle />
                            <p>{retiraMascara(revenda.petelefone2)}</p>
                        </div>

                        <div className="flex items-center gap-2">
                            <MdOutlineEmail />
                            <p>{revenda.peemail}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="border-t border-black/20 mt-10 pt-4 text-center text-xs text-black/80">
                © Copyright 2026 Mult Veículos | Todos os direitos reservados.
                <a className="ml-2" href="https://intermedioveiculos.com.br/">Intermédio Veículos Marketing Digital</a>
            </div>
        </footer>
    );
}
